import React from 'react';
export function StudioStory() {
  return <section id="story" className="bg-cream pb-20 md:pb-28" data-id="element-161" data-mp="1jn9lf25nwao9">
      <div className="mx-auto max-w-content px-5 md:px-8 lg:px-10" data-id="element-162" data-mp="1f6muvj8dokxf">
        <div className="relative bg-ink px-6 py-16 md:px-16 md:py-24" data-id="element-163" data-mp="10higkd4pf0ul">
          <div className="absolute left-0 top-0 h-full w-[3px] bg-violet" aria-hidden="true" data-id="element-164" data-mp="10fdzsulpi7cw" />
          <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-cream/55" data-id="element-165" data-mp="15guyqkkmrjqu">
            The studio
          </p>

          <div className="mt-8 max-w-4xl" data-id="element-166" data-mp="1y58vyy3wac1c">
            <h2 className="font-display text-[32px] font-semibold leading-[1.1] tracking-[-0.02em] text-cream md:text-[48px]" data-id="element-167" data-mp="1y3xw39dklofi">
              Independent by choice<span className="text-gold" data-id="element-168" data-mp="1o72yqtt19u2t">.</span>
            </h2>
            <p className="mt-8 max-w-3xl font-display text-[20px] font-medium leading-[1.45] text-cream/85 md:text-[26px]" data-id="element-169" data-mp="1o5i5r8mdaj72">
              Black Comet Labs is an independent home for original apps. We&rsquo;re building a
              focused portfolio across learning, lifestyle and gaming, with the freedom to follow a
              strong idea and the discipline to see it through.
            </p>
            <p className="mt-10 flex items-center gap-4 text-[15px] text-cream/70 md:text-[17px]" data-id="element-170" data-mp="3n20shik15n4f">
              <span className="h-px w-10 shrink-0 bg-violet" aria-hidden="true" data-id="element-171" data-mp="4vuu5j99qwkx" />
              The ambition is simple: build apps people are glad they found.
            </p>
          </div>
        </div>
      </div>
    </section>;
}